<template><div>
	<v-card class="d-none d-md-flex contnav">
		<Contents :lesson_list="lesson_list"/>
	</v-card>

	<div @click="drawer = !drawer" class="pull_drawer d-md-none elevation-6">
		<v-icon> {{ $mdi.ArrowExpandRight }} </v-icon>
	</div> 

	<v-flex d-flex justify-center justify-md-end justify-lg-center>
		<v-flex xs12 sm10 md8 lg6 px-3 style="overflow: hidden">
			<component ref="textbook" :is="Textbook || $g.NotTranslated"></component>
		</v-flex>
	</v-flex>

	<v-navigation-drawer temporary v-model="drawer" app>
		<Contents :lesson_list="lesson_list"/>
	</v-navigation-drawer>

</div></template>
		

<script>

import i18n from '@/i18n'
import Vue from 'vue'
import Contents from '@/components/TextbookContents'

export default {
	components: {Contents},
	data: function() {
		return {
			i18n,
			lesson_list: [],
			drawer: false
		}
	},
	methods: {

	},
	mounted() {
		this.lesson_list = this.$refs.textbook.all_lessons;
	},
	computed: {
		Textbook() {
			return i18n.choose[this.$store.state.language].components.Textbook;
		},
		xlesson_list() {
			if (!this.$refs.textbook) return [];
			return this.$refs.textbook.all_lessons;
		}
	}
}
</script>

<style>

.contnav {
	position: fixed;
	height: 90%;
	width: 300px;
	overflow-y: scroll;
}


.pull_drawer {
	cursor: pointer;
	background-color: #b9b8b8;
	xbackground-color: white;
	xborder: 1px solid black;
	position: fixed;
	top: 50vh;
	z-index: 2;
}

</style>